exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".title{font-size:24px;color:#1f1f1f;background:#fff;padding:20px 30px;font-weight:400}", "", {"version":3,"sources":["/divvit-app/client/components/Title/client/components/Title/style.styl","/divvit-app/client/components/Title/style.styl"],"names":[],"mappings":"AAAA,OACE,eAAA,cACA,gBACA,kBACA,eACA,CCCD","file":"style.styl","sourcesContent":[".title\n  font-size: 24px\n  color: text-light-grey\n  background: white\n  padding: 20px default-padding\n  font-weight: normal\n",".title {\n  font-size: 24px;\n  color: #1f1f1f;\n  background: #fff;\n  padding: 20px 30px;\n  font-weight: normal;\n}\n/*# sourceMappingURL=client/components/Title/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/Title/style.styl
// module id = 560
// module chunks = 0